import { render, staticRenderFns } from "./GearRatioTable.vue?vue&type=template&id=47eef8d1&scoped=true&"
import script from "./GearRatioTable.vue?vue&type=script&lang=js&"
export * from "./GearRatioTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eef8d1",
  null
  
)

export default component.exports